<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from "vue"
import { useBreakpoint } from "@/app/Checkout/composables/useBreakpoint"

const visible = ref(false)
const { isMobile } = useBreakpoint()

const open = () => (visible.value = true)
const close = () => (visible.value = false)
const toggle = () => (visible.value = !visible.value)

const eventBindings = computed(() => {
  if (isMobile.value) {
    return {
      click: toggle
    }
  }

  return {
    mouseenter: open,
    mouseleave: close
  }
})
</script>
